import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import NameField from '@/components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { FORM_FIELD_PATHS } from '../../constants';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const EntityAttributeField = ({ darkMode, errors, touched, number }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = useCompanyForm();
    const fieldName = () => {
        switch (number) {
            case 2:
                return FORM_FIELD_PATHS.ATTRIBUTE_2;
            case 3:
                return FORM_FIELD_PATHS.ATTRIBUTE_3;
            default:
                return FORM_FIELD_PATHS.ATTRIBUTE_1;
        }
    };

    const handleChange = (e) => {
        updateFormData(fieldName(), e.target.value);
    };
    const hasError = !!errors?.[fieldName()] && touched?.[fieldName()];
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Attribute {number}
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={NameField}
                        id={fieldName()}
                        name={fieldName()}
                        value={formData?.[fieldName()] || ''}
                        onChange={handleChange}
                        placeholder={`Enter Attribute ${number}`}
                        width="100%"
                        darkMode={darkMode}
                        isInvalid={hasError}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label={`Enter attribute ${number} for this entity`}
                        ariaLabel={`entity-attribute${number}-tip`}
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};
export default EntityAttributeField;
